export default __webpack_public_path__ + "static/media/Logo.a025194a.png";